<template>
  <footer-wrapper :class="apiData && 'show'">
    <div v-if="apiData" id="footer-wrapper">
      <div id="signup">
        <mc-subscribe
          :list="apiData.options.mail_scrape.mailchimp_url"
          :placeholder="apiData.options.mail_scrape.email_placeholder"
          :success="apiData.options.mail_scrape.success_message"
          :cta="apiData.options.mail_scrape.enews_cta"
        />
      </div>
      <div id="socials">
        <div class="socials-inner">
          <Facebook v-if="apiData.options.socials.facebook !== ''" :link="apiData.options.socials.facebook"/>
          <Instagram v-if="apiData.options.socials.instagram !== ''"  :link="apiData.options.socials.instagram"/>
          <Soundcloud v-if="apiData.options.socials.soundcloud !== ''"  :link="apiData.options.socials.soundcloud"/>
          <Spotify v-if="apiData.options.socials.spotify !== ''"  :link="apiData.options.socials.spotify"/>
          <Twitter v-if="apiData.options.socials.twitter !== ''"  :link="apiData.options.socials.twitter"/>
          <Youtube v-if="apiData.options.socials.youtube !== ''"  :link="apiData.options.socials.youtube"/>
          <div id="cr">
            <span class="date">&#169; {{ new Date().getFullYear() }} WILDER / </span>
            <router-link :to="'/privacy'"><span>PRIVACY</span></router-link>
          </div>
        </div>
      </div>
    </div>
  </footer-wrapper>
</template>

<script>
import { mapState } from 'vuex'
import styled from 'vue-styled-components'
import * as _ from '@/styles/mixins'
import Facebook from './socials/Facebook'
import Instagram from './socials/Instagram'
import Soundcloud from './socials/Soundcloud'
import Spotify from './socials/Spotify'
import Twitter from './socials/Twitter'
import Youtube from './socials/Youtube'
import McSubscribe from './McSubscribe'

// STYLES
const FooterWrapper = styled.footer`
  ${_.flexColumn};
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9000;
  width: 100%;
  #footer-wrapper {
    ${_.flexColumn};
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: flex-end;
    padding: 0 1rem;
    transform: translateY(-1rem);
  }
  ${_.media.desktop`
    height: 6rem;
    #footer-wrapper {
      display: grid;
      grid-template-columns: 3fr 1fr;
      transform: translateY(0);
      padding: 0 1rem;
    }
  `}
  #cr {
    ${_.flexCenteredAll};
    .date {
      color: black;
    }
    a {
      margin-left: .5rem;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
    ${_.media.desktop`
      height: 100%;
      justify-content: flex-end;
    `}
  }
  #socials {
    width: 100%;
    ${_.media.desktop`
      padding-left: 1rem;
    `}
  }
  #signup {
    width: 100%;
  }
  .socials-inner {
    ${_.flexRow};
    align-items: center;
    justify-content: space-between;
    background-color: black!important;
    width: 100%;
    border: 2px solid white;
    padding: 0 1rem;
    ${_.media.desktop`
      height: 5rem;
      padding-bottom: 0;
    `}
    * {
      color: white!important;
      fill: white!important;
    }
  }
  * {
    ${_.microType};
    ${_.mediumFont};
  }
`

// VUE
export default {
  components: {
    FooterWrapper,
    Facebook,
    Instagram,
    Soundcloud,
    Spotify,
    Twitter,
    Youtube,
    McSubscribe
  },
  computed: {
    ...mapState([
      'apiData',
      'scrollState'
    ])
  }
}
</script>
